// LogicBuilderPopup.js
import React, { useState } from 'react';
import './LogicBuilderPopup.css';

const OPERATORS = [
  { value: 'equal', label: 'is the value' },
  { value: 'notequal', label: 'is not the value' },
  { value: 'great', label: 'is greater than' },
  { value: 'greatequal', label: 'is greater than or equal to' },
  { value: 'less', label: 'is less than' },
  { value: 'lessequal', label: 'is less than or equal to' },
  { value: 'empty', label: 'is empty' },
  { value: 'notempty', label: 'is not empty' },
  { value: 'contains', label: 'contains the value' },
  { value: 'notcontain', label: 'does not contain the value' },
];

const LogicBuilderPopup = ({ fields, logic = [], onSave, onClose }) => {
  const [conditions, setConditions] = useState(logic);

  const systemFields = [
    { name: 'company_number', label: 'Company Number', type: 'text' },
    { name: 'company_name', label: 'Company Name', type: 'text' },
    { name: 'registered_address', label: 'Registered Address', type: 'address' },
    { name: 'trading_address', label: 'Trading Address', type: 'address' },
  ];

  const allFields = [...fields, ...systemFields];

  const updateCondition = (index, key, value) => {
    const updated = [...conditions];
    updated[index] = { ...updated[index], [key]: value };
    setConditions(updated);
  };

  const addCondition = () => {
    setConditions([...conditions, { field: '', operator: '', value: '', join: 'AND' }]);
  };

  const removeCondition = (index) => {
    const updated = [...conditions];
    updated.splice(index, 1);
    setConditions(updated);
  };

  return (
    <div className="logic-popup">
      <div className="logic-popup-header">
        <h3>Logic Builder</h3>
        <button onClick={onClose} className="close-btn">×</button>
      </div>

      <div className="logic-popup-body">
        {conditions.map((cond, idx) => (
          <div key={idx} className="logic-row">
            {idx > 0 && (
              <select
                key={`con_sel_${idx}`}
                value={cond.join || 'AND'}
                onChange={(e) => updateCondition(idx, 'join', e.target.value)}
              >
                <option value="AND">AND</option>
                <option value="OR">OR</option>
              </select>
            )}
            <select
              value={cond.field}
              onChange={(e) => updateCondition(idx, 'field', e.target.value)}
            >
              <option key='con_fld_def' value="">Select Field</option>
              {allFields.map((f,i) => (
                <option key={`${f.name}_${i}`} value={f.name}>{f.label || f.name}</option>
              ))}
            </select>
            <select
              value={cond.operator}
              onChange={(e) => updateCondition(idx, 'operator', e.target.value)}
            >
              <option value="">Select Operator</option>
              {OPERATORS.map((op) => (
                <option key={op.value} value={op.value}>{op.label}</option>
              ))}
            </select>
            {!["empty", "notempty"].includes(cond.operator) && (
              <input
                type="text"
                value={cond.value || ''}
                onChange={(e) => updateCondition(idx, 'value', e.target.value)}
              />
            )}
            <button onClick={() => removeCondition(idx)} className="remove-btn">✕</button>
          </div>
        ))}
        <button onClick={addCondition} className="add-btn">+ Add Condition</button>
      </div>

      <div className="logic-popup-footer">
        <button onClick={() => onSave(conditions)} className="save-btn">Save Logic</button>
      </div>
    </div>
  );
};

export default LogicBuilderPopup;
